import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BackgroundPattern = _resolveComponent("BackgroundPattern")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["klimaheld-container", _ctx.background])
  }, [
    _createVNode(_component_BackgroundPattern),
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}